const Images = {
    fbIcon : require('../assets/images/fb.png'),
    authorIcon : require('../assets/images/authorIcon.png'),
    examIcon : require('../assets/images/examIcon.png'),
    groupIcon : require('../assets/images/groupIcon.png'),
}

export default Images;


// WEBPACK FOOTER //
// ./src/config/images.js